import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import TextCurriculum from '../../text/TextCurriculum'
import { Input, ListSubheader } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import isEmpty from 'lodash/isEmpty'
import IconTooltipButton from '../../button/IconTooltipButton'
import { groupBy as groupByLoadash } from 'lodash'

/* 	InputField
 *	@params id 			string	 	identificador input
 * 	@params label 		string  	label input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params error		bool 		enable class error
 *	@params helperText	string 		helper text
 *	@params onChange	function 	function change
 *	@params InputProps	Object
 *	More Information https://material-ui.com/es/api/text-field/
 */

const SelectField = ({
  id,
  label,
  placeholder,
  caret,
  name,
  loading,
  onClear,
  className,
  value,
  error,
  disabled,
  helperText,
  onChange,
  InputProps,
  options,
  onBlur,
  displayEmpty = true,
  variant = 'standard',
  groupBy
}) => {
  const RenderOptions = () => {
    if (isEmpty(options)) {
      return (
        <MenuItem value='' disabled>
          No options
        </MenuItem>
      )
    }
    if (groupBy) {
      const groupedOptions = groupByLoadash(options, groupBy)
      return Object.keys(groupedOptions).map((group) => [
        <ListSubheader key={group}>{group}</ListSubheader>,
        groupedOptions[group].map((op, i) => (
          <MenuItem key={`${id}-${i}`} value={op.value} disabled={op.disabled} className={op.className ?? ''}>
            {op.label}
          </MenuItem>
        ))
      ])
    }
    return options.map((op, i) => (
      <MenuItem key={`${id}-${i}`} value={op.value} disabled={op.disabled} className={op.className ?? ''}>
        {op.label}
      </MenuItem>
    ))
  }
  return (
    <FormControl variant={variant} fullWidth error={!!error}>
      {label && (
        <InputLabel shrink>
          {caret && <TextCurriculum className='text-x-medium' label={label} />}
          {!caret && <>{label}</>}
        </InputLabel>
      )}
      <Select
        variant={variant}
        fullWidth
        id={id}
        value={value ? value : ''}
        name={name}
        error={!!error}
        disabled={disabled || loading}
        onChange={onChange}
        onBlur={onBlur}
        input={
          <Input
            variant={variant}
            placeholder={placeholder}
            endAdornment={
              <React.Fragment>
                <div className='flex items-center justify-center absolute right-4 bg-background'>
                  {loading ? (
                    <FontAwesomeIcon className='text-muted-foreground' icon='circle-notch' spin />
                  ) : null}
                  {onClear && !loading ? (
                    <IconTooltipButton
                      title='Clear'
                      className='text-muted-foreground cursor-pointer'
                      onClick={onClear}
                      icon={['fal', 'times']}
                      style={{
                        height: 20,
                        width: 20
                      }}
                    />
                  ) : null}
                </div>
              </React.Fragment>
            }
          />
        }
        className={`underline ${className ?? ''}`}
        inputProps={isEmpty(value) ? { className: 'opacity-50', ...InputProps } : InputProps}
        displayEmpty={displayEmpty || placeholder ? true : false}
      >
        {placeholder && (
          <MenuItem value='' disabled>
            {placeholder}
          </MenuItem>
        )}
        {RenderOptions()}
      </Select>
      {helperText && (
        <FormHelperText error={!!error}>
          {caret && <TextCurriculum className='text-x-medium' label={helperText} />}
          {!caret && <>{helperText}</>}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default SelectField
